// extracted by mini-css-extract-plugin
module.exports = {"root":"WhatsAppWidget_root__1S6H8"};